import React from "react";

const CustomInput = ({ register, errors, name, placeholder, label }) => {
  return (
    <div>
      {label && (
        <label style={{ display: "block", marginBottom: "5px" }}>{label}</label>
      )}
      <input
        type="text"
        placeholder={placeholder}
        name={name}
        class="form-control"
        {...register(name, {
          required: true,
          validate: (value) =>
            value.trim() !== "" || "only space are not allowed",
        })}
      />
      {errors?.[name] ? (
        <p style={{ color: "red" }}>This field is required</p>
      ) : null}
    </div>
  );
};

export default CustomInput;
